module.exports = __webpack_public_path__ + "./images/p25.JPG?f6853309e279f32c97f6a7b674f57d83";


//////////////////
// WEBPACK FOOTER
// ./src/products/p25.JPG
// module id = 61
// module chunks = 0